import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { feeEngineEndpoints } from "@/features/fee-engine/api/endpoints";
import type { SubscriptionPlanDto } from "@/features/fee-engine/api/dto";

/** Détail d'un plan d'abonnement (`GET /SubscriptionPlans/{id}`). */
export const useSubscriptionPlan = (planId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.FEE_SUBSCRIPTION_PLAN_DETAIL(planId),
    queryFn: () =>
      fetchDataGet<SubscriptionPlanDto>({
        url: feeEngineEndpoints.subscriptionPlans.detail(planId),
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(planId),
  });
